import { BasePaginatedUseCase } from "../../../../../common/domain/useCases/base_paginated_use_case";
import { HabilidadeItem } from "../../models/habilidade_item";
import { IGetHabilidadeItemsUseCase } from "../../../presentation/useCases/read/get_habilidade_items_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * GetHabilidadeItemsUseCase
 */

export class GetHabilidadeItemsUseCase extends BasePaginatedUseCase<HabilidadeItem> implements IGetHabilidadeItemsUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) {
    super();
  }

  async getHabilidadeItemsNew(
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getHabilidadeItems(
      undefined,
      page,
      pageSize,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }

  async getHabilidadeItems(
    idHabilidade: number,
    page: number,
    pageSize: number,
  ): Promise<void> {
    const response = await this.repository.getHabilidadeItems(
      idHabilidade,
      page,
      pageSize,
    );

    this._items = response.items;
    this._totalItems = response.totalItems;
    this._totalPages = response.totalPages;
    this._currentPage = response.currentPage;
    this._pageSize = response.pageSize;
  }
}